interface FetchFileFromPresignedUrlParams {
  url: string;
  fileName: string;
  signal?: AbortSignal;
}

export async function fetchFileFromPresignedUrl({
  url,
  fileName,
  signal,
}: FetchFileFromPresignedUrlParams): Promise<File> {
  const response = await fetch(url, { signal });

  if (!response.ok) {
    throw new Error(
      `Failed to fetch file from presigned URL (status ${response.status})`,
    );
  }

  const blob = await response.blob();
  return new File([blob], fileName, {
    type: blob.type || 'application/octet-stream',
  });
}

interface UploadFileToPresignedUrlParams {
  url: string;
  file: File;
  contentType: string;
  contentLength: number;
  signal?: AbortSignal;
}

export async function uploadFileToPresignedUrl({
  url,
  file,
  contentType,
  contentLength,
  signal,
}: UploadFileToPresignedUrlParams): Promise<void> {
  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': contentType,
      'Content-Length': String(contentLength),
    },
    body: file,
    signal,
  });

  if (!response.ok) {
    throw new Error(`S3 upload failed with status ${response.status}`);
  }
}
